module.exports = __webpack_public_path__ + "static/img/footer_15.e2dda75.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/footer_15.jpg
// module id = Aav7
// module chunks = 7